import { SearchBar } from '@ui/common/search-bar.tsx';
import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AllCategoriesList } from '@features/categories/all-categories-list.tsx';

export const CategoriesPage = () => {
  const set = useNavbar();

  const navigate = useNavigate();

  useEffect(() => {
    set.categories();
  }, []);
  return (
    <>
      <SearchBar onPress={() => navigate('/search')} isEditable={false} />
      <AllCategoriesList />
    </>
  );
};
